export const NAMESPACE_TYPES = {
  PROJECT: 'project',
  GROUP: 'group',
};
